// @flow

import Resource from 'speed-js-core/src/api/Resource';
import ClientServiceResource from 'esm-web-pro/api/resources/ClientServiceResource';

export default class ClientOrganisationResource extends Resource {
    basePath: string = 'entities/clients/organisation/';

    objectPath: string = 'entities/clients/organisation/{ident}/';

    nestedResources = {
        services: ClientServiceResource,
    };

    services: ClientServiceResource;

    merge(id: string, data: Object): Promise<Object> {
        return this.client._request(
            `entities/clients/organisation/${id}/merge/`, 'POST', data,
        ).then((response) => response.data);
    }
}
